import environment from "environment";
import EffectUtility from "../../utilities/EffectUtility";
import InfluencerFacebookPlatformPostModel from "./models/InfluencerFacebookPlatformPostModel";
import InfluencerInstagramPlatformPostModel from "./models/InfluencerInstagramPlatformPostmodel";
import InfluencerPlatformAccountsModel from "./models/InfluencerPlatformAccountsModel";
import InfluencerQuoraPlatformPostModel from "./models/InfluencerQuoraPlatformPostModel";
import InfluencerQuoraPlatformPutModel from "./models/InfluencerQuoraPlatformPutModel";
import InfluencerYoutubePlatformPostModel from "./models/InfluencerYoutubePlatformPostModel";

export default class InfluencerPlatformEffect {
  static async requestInfluencerPlatforms(params) {
    const endpoint = environment.api.influencerPlatformAccounts;
    return EffectUtility.getToModel(
      InfluencerPlatformAccountsModel,
      endpoint,
      params
    );
  }

  static async requestPostInfluencerFacebookAccount(data) {
    const endpoint = environment.api.influencerFacebookPlatform + "/add";
    return EffectUtility.postToModel(
      InfluencerFacebookPlatformPostModel,
      endpoint,
      data
    );
  }

  static async requestPostInfluencerInstagramAccount(data) {
    const endpoint = environment.api.influencerInstagramPlatform + "/add";
    return EffectUtility.postToModel(
      InfluencerInstagramPlatformPostModel,
      endpoint,
      data
    );
  }

  static async requestPostInfluencerYoutubeAccount(data) {
    const endpoint = environment.api.influencerYoutubePlatform + "/add";
    return EffectUtility.postToModel(
      InfluencerYoutubePlatformPostModel,
      endpoint,
      data
    );
  }

  static async requestPutInfluencerFacebookAccount(data, id) {
    const endpoint = environment.api.influencerFacebookPlatform + "/" + id;
    return EffectUtility.putToModel(
      InfluencerFacebookPlatformPostModel, // PUT model is also same as post model
      endpoint,
      data
    );
  }

  static async requestPutInfluencerInstagramAccount(data, id) {
    const endpoint = environment.api.influencerInstagramPlatform + "/" + id;
    return EffectUtility.putToModel(
      InfluencerInstagramPlatformPostModel, // PUT model is also same as post model
      endpoint,
      data
    );
  }

  static async requestPutInfluencerYoutubeAccount(data, id) {
    const endpoint = environment.api.influencerYoutubePlatform + "/" + id;
    return EffectUtility.putToModel(
      InfluencerYoutubePlatformPostModel, // PUT model is also same as post model
      endpoint,
      data
    );
  }

  static async requestPostInfluencerQuoraAccount(data) {
    const endpoint = environment.api.influencerQuoraPlatform + "/add";
    return EffectUtility.postToModel(
      InfluencerQuoraPlatformPostModel,
      endpoint,
      data
    );
  }

  static async requestPutInfluencerQuoraAccount(data, id) {
    const endpoint = environment.api.influencerQuoraPlatform + "/" + id;
    return EffectUtility.putToModel(
      InfluencerQuoraPlatformPutModel, // PUT model is also same as post model
      endpoint,
      data
    );
  }

  static async requestPostInfluencerPlaystoreAccount(data) {
    const endpoint = environment.api.influencerPlaystorePlatform + "/add";
    return EffectUtility.postToModel(
      InfluencerQuoraPlatformPostModel,
      endpoint,
      data
    );
  }

  static async requestPutInfluencerPlaystoreAccount(data, id) {
    const endpoint = environment.api.influencerPlaystorePlatform + "/" + id;
    return EffectUtility.putToModel(
      InfluencerQuoraPlatformPutModel, // PUT model is also same as post model
      endpoint,
      data
    );
  }

  //twitter platform

  static async requestPostInfluencerTwitterAccount(data) {
    const endpoint = environment.api.influencerTwitterPlatform + "/add";
    return EffectUtility.postToModel(
      InfluencerQuoraPlatformPostModel,
      endpoint,
      data
    );
  }

  static async requestPutInfluencerTwitterAccount(data, id) {
    const endpoint = environment.api.influencerTwitterPlatform + "/" + id;
    return EffectUtility.putToModel(
      InfluencerQuoraPlatformPutModel, // PUT model is also same as post model
      endpoint,
      data
    );
  }
}
